import * as React from "react";
import LazyLoad from "react-lazyload";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkCard, UitkCardContent, UitkCardLink, UitkCardMedia, UitkCardTextSegment } from "uitk-react-cards";

import { MediaAttribution } from "components/utility/MediaAttributionUtil";
import { LazyLoaderPlaceHolder } from "components/utility/LazyLoaderPlaceholderWrapper";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { VisitorBlogCardProps } from "../typings";

const VisitorBlogCard = (props: VisitorBlogCardProps) => {
  const { visitorBlog, visitorBlogImageUrl } = props;
  const { name, description, media, link } = visitorBlog;

  const attribution = MediaAttribution(media, name);

  return (
    <UitkCard>
      <UitkCardMedia>
        <UitkFigure>
          <LazyLoad placeholder={<LazyLoaderPlaceHolder name={name} />} offset={250}>
            <UitkImage alt={attribution.attributionAltText} src={visitorBlogImageUrl} />
          </LazyLoad>
          {attribution.attributionText}
        </UitkFigure>

        <UitkCardContent>
          <UitkCardTextSegment>
            <UitkHeading level={4} size={400}>
              {name}
            </UitkHeading>
            <UitkText size={300} spacing="two">
              {description}
            </UitkText>
          </UitkCardTextSegment>
        </UitkCardContent>

        <UitkCardLink>
          <TrackedLink moduleName="TG.LP" href={link} rfrr="Dest.Articles" linkName={name}>
            {name}
          </TrackedLink>
        </UitkCardLink>
      </UitkCardMedia>
    </UitkCard>
  );
};

export default VisitorBlogCard;
